import Http from '../../network/Http'
import {ApiResponse} from '../../network/response/ApiResponse'
import {Nullable} from '../../app/TypeHelpers'
import {ASSOC_ACCOUNTING_DEPT_CD, RECEIVING_AGENCY_CD} from '../../CodeMaster'

export interface AssocAccountingDept {
    assocAccountingDeptCd: Nullable<ASSOC_ACCOUNTING_DEPT_CD>
    receivingAgencyCd: Nullable<RECEIVING_AGENCY_CD>
}

export default class CondominiumsRepository {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    async getFacilityReserveIntroductory(condominiumCd: string): Promise<string> {
        const response: ApiResponse<Nullable<string>> =
            await this.http.get(`/api/condominiums/${condominiumCd}/facility-reserve-introductory`)
        const apiResponse: ApiResponse<Nullable<string>> =
            ApiResponse.from(response, t => t)
        return apiResponse.details || ''
    }

    async getAssocAccountingDept(condominiumCd: string): Promise<AssocAccountingDept> {
        const response = await this.http.get(`/api/condominiums/${condominiumCd}/assoc-accounting-dept`)
        const apiResponse: ApiResponse<AssocAccountingDept> =
            ApiResponse.from(response, t => {
                return {
                    assocAccountingDeptCd: t.assocAccountingDeptCd === null ? null :
                        ASSOC_ACCOUNTING_DEPT_CD.codeToEnumConstants(t.assocAccountingDeptCd),
                    receivingAgencyCd: t.receivingAgencyCd === null ? null :
                        RECEIVING_AGENCY_CD.codeToEnumConstants(t.receivingAgencyCd),
                }
            })
        return apiResponse.details
    }
}
